import { saveAs } from 'file-saver';
import { getFileExtension } from './stringHelper';
import { showModalError } from 'utilities/modal';
import { t } from './lang';

// import XLS from 'assets/images/icons/xls.svg';
// import DOC from 'assets/images/icons/doc.svg';
// import PNG from 'assets/images/icons/png.svg';
// import JPG from 'assets/images/icons/jpg.svg';
// import PDF from 'assets/images/icons/pdf.svg';
// import FILE from 'assets/images/file/File.svg';

export const MONTH_IN_TEXT_FORMAT = 'MMM DD, YYYY';
export const IMG_RATIO_TYPE = {
  SQUARE: 'SQUARE',
  PANORAMIC: 'PANORAMIC',
  RECTANGLE_32: 'RECTANGLE_32',
  RECTANGLE_43: 'RECTANGLE_43',
  LANDSCAPE: 'LANDSCAPE',
};

export const IMG_RATIO = {
  [IMG_RATIO_TYPE.SQUARE]: '1/1',
  [IMG_RATIO_TYPE.PANORAMIC]: '16/9',
  [IMG_RATIO_TYPE.RECTANGLE_32]: '3/2',
  [IMG_RATIO_TYPE.RECTANGLE_43]: '4/3',
  [IMG_RATIO_TYPE.LANDSCAPE]: '1.59/1',
};

import { getBase64 } from './common';

export const SheetJSFT = ['csv']
  .map(function (x) {
    return '.' + x;
  })
  .join(',');

export const downloadCsvBase64 = async (str, name) => {
  const blob = await fetch(`data:text/csv;base64,${str}`).then((res) =>
    res.blob()
  );
  const url = URL.createObjectURL(blob);
  saveAs(url, `${name}.csv`);
};

export const downloadFileFromUrl = saveAs;

// export const getFileFormatImage = (extension) => {
//   let iconType = FILE;
//   switch (extension.toLowerCase()) {
//     case 'jpeg':
//     case 'jpg':
//       iconType = JPG;
//       break;
//     case 'png':
//       iconType = PNG;
//       break;
//     case 'csv':
//     case 'xls':
//     case 'xlsx':
//       iconType = XLS;
//       break;
//     case 'doc':
//     case 'docx':
//       iconType = DOC;
//       break;
//     case 'pdf':
//       iconType = PDF;
//       break;
//     default:
//       iconType = FILE;
//   }
//   return iconType;
// };

export const getImageFromFileName = (fileName) => {
  const extension = getFileExtension(fileName);
  return getFileFormatImage(extension);
};

export const getImageFromFile = async (file, showImage = true) => {
  const { name, type, preview, isImage } = file;
  if (showImage) {
    if (preview && isImage) {
      return preview;
    }
    if (type && type.indexOf('image') > -1) {
      const image = await getBase64(file);
      return image;
    }
  }
  let extension = file.extension || getFileExtension(name);
  extension = extension.replace('.', '');
  return getFileFormatImage(extension);
};

export const bytesToSize = (bytes) => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export const LIMIT_VIDEO_SIZE_MB = 100;
export const LIMIT_IMAGE_SIZE_KB = 110;
export const LIMIT_IMAGE_SIZE_MB = 1;

export const bytesToMB = (bytes) => {
  return bytes / Math.pow(1024, 2);
};

export const bytesToKB = (bytes) => {
  return bytes / Math.pow(1024, 1);
};

export const getImageDimensionsFromUrl = async (url) => {
  const fileImg = await fetch(url).then((r) => r.blob());
  return fileImg;
};

const getImageWidthHeightFromUrl = async (url) => {
  if (!url) {
    return {
      width: null,
      height: null,
    };
  }

  const img = new Image();
  img.src = url;
  await img.decode();
  return { width: img.width, height: img.height };
};

export const getImageDimensionsFromFile = (file) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = function () {
      file.dimensions = [this.width, this.height].join('x');
      file.width = this.width;
      file.height = this.height;
      resolve(file);
    };
    img.onerror = function (err) {
      reject(err);
    };
    img.src = URL.createObjectURL(file);
  });
};

export const calculateGCD = (width, height) => {
  if (height === 0) return width;
  return calculateGCD(height, width % height);
};

export const getVideoMetadataFromFile = (file, checkCreative) => {
  return new Promise((resolve, reject) => {
    let video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = function () {
      URL.revokeObjectURL(video.src);
      const ratio = calculateGCD(video.videoWidth, video.videoHeight);

      const videoInfo = {
        duration: Math.floor(video.duration),
        ratio: `${video.videoWidth / ratio}:${video.videoHeight / ratio}`,
      };
      if (checkCreative) {
        resolve({
          videoInfo,
          videoWidth: video.videoWidth,
          videoHeight: video.videoHeight,
        });
      } else resolve(videoInfo);
    };

    video.onerror = function (err) {
      reject(err);
    };

    video.src = URL.createObjectURL(file);
  });
};

export const csvFileToArray = (csvContent) => {
  try {
    csvContent = csvContent.trim();
    if (!csvContent) {
      return [];
    }

    const csvHeader = csvContent.slice(0, csvContent.indexOf('\n')).split(',');
    const csvRows = csvContent.slice(csvContent.indexOf('\n') + 1).split('\n');

    const array = csvRows.map((i) => {
      const values = i.split(',');
      const obj = csvHeader.reduce((object, header, index) => {
        object[header.trim()] = values[index].replaceAll('\r', '');
        return object;
      }, {});
      return obj;
    });

    return array;

  } catch (error) {
    showModalError({
      title: t('file.invalid_csv_title'),
      content: t('file.invalid_csv_content'),
    });
  }
};

export const getImgRatioFromUrl = async (url) => {
  const { width, height } = await getImageWidthHeightFromUrl(url);
  const imageRatio = width / height;

  let closestMatch = null;
  let closestDifference = Number.MAX_VALUE;

  for (const key in IMG_RATIO) {
    const [expectedWidth, expectedHeight] = IMG_RATIO[key]
      .split('/')
      .map(Number);
    const expectedRatio = expectedWidth / expectedHeight;
    const difference = Math.abs(imageRatio - expectedRatio);

    if (difference < closestDifference) {
      closestMatch = key;
      closestDifference = difference;
    }
  }

  return closestMatch;
};

export const generateVideoThumbnail = (videoFile) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadeddata = function () {
      // Set video to first frame
      video.currentTime = 0;
    };

    video.onseeked = function () {
      // Create canvas and draw video frame
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert canvas to blob
      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(video.src);
          resolve(blob);
        },
        'image/jpeg',
        0.8
      );
    };

    video.onerror = function (err) {
      URL.revokeObjectURL(video.src);
      reject(err);
    };

    video.src = URL.createObjectURL(videoFile);
  });
};
